import {NgModule} from '@angular/core';
import {KnowledgeServiceProvider} from "./services/knowledge-service/knowledge-service";
import {File} from '@ionic-native/file';
import {FileTransfer, FileTransferObject} from "@ionic-native/file-transfer";
import {FileOpener} from "@ionic-native/file-opener";

@NgModule({
  providers: [
    KnowledgeServiceProvider,
    File,
    FileTransfer,
    FileTransferObject,
    FileOpener
  ]
})
export class SellionsKnowledgeModule {}



// WEBPACK FOOTER //
// ./src/modules/knowledge/knowledge.module.ts